<template>
  <v-app>
      <router-view/>
    <message-page></message-page>
  </v-app>
</template>

<script>
import {bus} from "@/main";
import MessagePage from "@/components/message";

export default {
  name: 'App',
  components: {MessagePage},
  data: () => ({
  }),
  watch:{
    active:function (){
      bus.$emit('message', {
        show:false
      })
    }
  }

};
</script>
